import sendRequest from "@/libs/sendRequest"

const category = {
    namespaced: true,
    state: {
        category: {},
        categories: [],
        error: false,
        last_page: null,
        total_pages: null
    },
    getters: {
        getTravellerCategory: (state) => state.category,
        getCategories: (state) => state.categories,
        getLastPage: (state) => state.last_page,
        getTotalPages: (state) => state.total_pages,
        getError: (state) => state.error
    },
    mutations: {
        setTravellerCategory: (state, payload) => state.category = payload,
        setCategories: (state, payload) => state.categories = payload,
        setLastPage: (state, payload) => state.last_page = payload,
        setTotalPages: (state, payload) => state.total_pages = payload,
        setError: (state, payload) => state.error = payload,
    },
    actions: {
        list: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/category/list', 'GET', null, query, custom_headers)
            if(response.success && response.data) {
                if(query.datatable) {
                    commit('setCategories', response.data.list.result)
                    commit('setTotalPages', response.data.list.total_pages)
                    commit('setLastPage', response.data.list.total_pages == query.page)
                } else {
                    commit('setCategories', response.data.list)
                }
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        view: async({commit, dispatch, rootGetters}, query) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/category/view', 'GET', null, query, custom_headers)
            if(response.success && response.data) {
                commit('setTravellerCategory', response.data.view)
                dispatch('hiddenLoading', null, { root: true })
            }
            else if(!response.success && response.errors) {
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', 'An error has occurred try later', { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        add: async({commit, dispatch, rootGetters}, body) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/category/add', 'POST', body, null, custom_headers)
            if(response.success && response.data) {
                dispatch('showAlert', 'The category has been added successfully', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_name_category': messages.push('Error: Please add a category name.'); break
                        case 'error_category_already_exists': messages.push('Error: The category already exists.'); break
                        default: messages.push('An error has occurred try later'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        update: async({commit, dispatch, rootGetters}, data) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/category/update', 'PUT', data.body, data.query, custom_headers)
            if(response.success && response.data) {
                dispatch('showAlert', 'Category updated successfully', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_name_category': messages.push('Error: Please add a category name.'); break
                        case 'error_category_inactive': messages.push('Error: Category is inactive.'); break
                        case 'error_category_already_exists': messages.push('Error: The category already exists.'); break
                        default: messages.push('An error has occurred try later'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        },
        delete: async({commit, dispatch, rootGetters}, id) => {
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('admin/catalogs/category/delete', 'DELETE', null, { id_category: id }, custom_headers)
            if(response.success && response.data) {
                dispatch('showAlert', 'The category has been successfully removed', { root: true })
                commit('setError', false)
            }
            else if(!response.success && response.errors) {
                let messages = []
                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_category_has_subcategories': messages.push('Please delete all subcategories before deleting this category.'); break
                        default: messages.push('An error has occurred try later'); break
                    }
                }
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', messages, { root: true })
            }
            else { dispatch('lostConection', null, { root: true }) }
        }
    }
}

export default category
